<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <div class="top-list-toolbar">
                <div>
                    <h4 class="text-primary"> Purchase Retur</h4>
                    <ol class="breadcrumb breadcrumb-card-header">
                    <li class="breadcrumb-item">
                        <a href="javascript:void(0);" @click="backParent">Purchase</a>
                    </li>
                    <li class="breadcrumb-item active">
                        <!-- <span v-if="delivery.id === null">New</span> -->
                        <!-- <span v-else>{{ delivery.deliver_no }}</span> -->
                    </li>
                    </ol>
                    <button type="button" @click="backParent" class="btn btn-sm btn-hard-outline-primary pull-left"><i class="fa fa-reply" aria-hidden="true"></i> Back</button>
                    <button v-if="dataReturn.id === null" type="button" @click="createRetur" class="btn btn-sm btn-soft-primary pull-left"><i class="fa fa-mail-forward" aria-hidden="true"></i> Process</button>
                    <button v-else type="button" @click="updateRetur" class="btn btn-sm btn-soft-primary pull-left"><i class="fa fa-mail-forward" aria-hidden="true"></i> Update</button>
                    <button class="btn btn-sm btn-soft-danger pull-left" @click="createScrap"><i class="fa fa-trash"></i> Scrap</button>
                    <button class="btn btn-sm btn-info pull-left" @click="printRetur"><i class="fa fa-print"></i> Print</button>
                    <!-- <button v-else type="button" @click="updateDelivery" class="btn btn-sm btn-soft-primary pull-left"><i class="fa fa-save" aria-hidden="true"></i> Update</button> -->
                </div>
                </div>
            </div>
        </div>
        <div class="card card-list">
            <div class="card-body">
                <div class="row">
                  <div class="col-md-4">
                    <strong class="font-24">Retur Data:</strong>
                    <dl class="row dl-custom font-12">
                      <dt class="col-md-4">Retur No.</dt>
                      <dd class="col-md-8">
                        <span v-if="dataReturn.return_no === null">New</span>
                        <span v-else>{{ dataReturn.return_no }}</span>
                      </dd>
                      <dt class="col-md-4">Date</dt>
                      <dd class="col-md-8">
                        <datetime v-model="dataReturn.return_date" format="dd/MM/yyyy" class="form-control form-control-lite" value-zone="local" zone="local"></datetime>
                      </dd>
                      <dt class="col-md-4">Tax</dt>
                      <dd class="col-md-8">
                        <select v-model="dataReturn.tax_id" class="form-control form-control-lite" @change="setTax">
                          <option v-for="t in taxList" :key="t.id" :value="t.id">Tax: {{ t.name }}</option>
                        </select>
                      </dd>
                      <dt class="col-md-4">Deliver Date</dt>
                      <dd class="col-md-8">
                          <datetime v-model="dataReturn.deliver_date" format="dd/MM/yyyy" class="form-control form-control-lite" value-zone="local" zone="local"></datetime>
                      </dd>
                      <dt class="col-md-4">Notes</dt>
                      <dd class="col-md-8">
                        <textarea rows="2" v-model="dataReturn.notes" class="form-control form-control-list"/>
                      </dd>
                    </dl>
                  </div>
                  <div class="col-md-4">
                      <div class="float-left">
                      <address class="font-13">
                            <strong class="font-24">Vendor</strong>
                            <dl class="row dl-custom font-12">
                                <dt class="col-md-6">Vendor No.</dt>
                                <dd class="col-md-6">{{ purchasing.vendor.vendor_no }}</dd>
                                <dt class="col-md-6">Name</dt>
                                <dd class="col-md-6">{{ purchasing.vendor.name }}</dd>
                                <dt class="col-md-6">Phone</dt>
                                <dd class="col-md-6">{{ purchasing.vendor.phone }}</dd>
                                <dt class="col-md-6">Address</dt>
                                <dd class="col-md-6">{{ purchasing.vendor.address }}</dd>
                            </dl>
                      </address>
                      </div>
                  </div>
                  <div class="col-md-4">
                      <div class="float-left">
                      <address class="font-13">
                          <strong class="font-24">Purchase</strong>
                          <br><b  class="font-16">{{ purchasing.purchasing_no }}</b>
                          <br>{{ purchasing.purchasing_date | dateFormat('DD/MM/YYYY')}}
                          <br><b>{{ purchasing.taxes }}</b>
                      </address>
                      </div>
                  </div>
                </div>
                <hr class="mt-5 mb-5">
                <div class="row">
                    <div class="col-md-4">
                        <strong class="font-24">Product</strong>
                        <div class="table-responsive">
                            <table class="table table-item table-sm table-striped">
                                <thead>
                                    <th>Product</th>
                                    <th>Qty</th>
                                    <th>Price</th>
                                    <th>Discount</th>
                                    <th>Tax</th>
                                    <th>Total</th>
                                    <th>#</th>
                                </thead>
                                <tbody>
                                <tr v-for="(d, index) in purchasing.details" :key="index">
                                    <td><b>[{{ d.product_no }}]</b> {{ d.description }}</td>
                                    <td>{{ d.qty }}</td>
                                    <td>{{ d.price }}</td>
                                    <td>{{ d.discount | currency }}</td>
                                    <td>{{ d.tax | currency }}</td>
                                    <td>{{ d.total | currency }}</td>
                                    <td>
                                        <button type="button" class="btn btn-sm btn-outline-primary" @click="addToReturn(index)"><i class="fa fa-share"></i></button>
                                    </td>
                                </tr>
                                </tbody>
                                <tfoot>
                                <tr>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td><b>Discount:</b></td>
                                    <td>{{ purchasing.discount }}</td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td><b>Tax:</b></td>
                                    <td>{{ purchasing.tax }}</td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td><b>Total:</b></td>
                                    <td>{{ purchasing.total }}</td>
                                </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                    <div class="col-md-8">
                        <strong class="font-24">Retur Product:</strong>
                        <div class="table-responsive">
                            <table class="table table-item table-sm table-striped">
                                <thead>
                                    <th>Product No.</th>
                                    <th>Product</th>
                                    <th>Warehouse</th>
                                    <th>Qty</th>
                                    <th>Uom</th>
                                    <th>Amount</th>
                                    <th>Tax</th>
                                    <th>Total</th>
                                    <th>#</th>
                                </thead>
                                <tbody>
                                    <tr v-for="(r, index) in purchasingReturn" :key="index">
                                        <td><b>{{ r.product_no }}</b></td>
                                        <td>{{ r.product }}</td>
                                        <td>{{ r.warehouse_no }}</td>
                                        <td>
                                            <input type="text" class="form-control" v-model="r.qty" @keyup="calcrow(index)"/>
                                        </td>
                                        <td>
                                            <select v-model="r.uom_id" class="form-control" disabled="disabled">
                                                <option v-for="u in uomList" :key="u.id" :value="u.id">{{ u.name }}</option>
                                            </select>
                                        </td>
                                        <td>
                                            <input type="type" class="form-control" v-money="money" v-model="r.amount" />
                                        </td>
                                        <td>{{ r.tax | currency }} ({{ r.taxes }})</td>
                                        <td class="text-right">{{ r.total | currency }}</td>
                                        <td>
                                            <button type="button" class="btn btn-sm btn-outline-danger" @click="removeReturn(index)"><i class="fa fa-trash"></i></button>
                                        </td>
                                    </tr>
                                    <tr>
                                      <td colspan="7" class="text-right"><b>subtotal</b></td>
                                      <td class="text-right">{{ totalSubtotalDetailReturn | currency }}</td>
                                      <td></td>
                                    </tr>
                                    <tr>
                                      <td colspan="7" class="text-right"><b>Tax</b></td>
                                      <td class="text-right">{{ totalTaxDetailReturn | currency }}</td>
                                      <td></td>
                                    </tr>
                                    <tr>
                                      <td colspan="7" class="text-right"><b>Total</b></td>
                                      <td class="text-right">{{ totalDetailReturn | currency }}</td>
                                      <td></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div class="row">
          <div class="col-md-4"><pre>{{ dataCollect }}</pre></div>
          <div class="col-md-4"><pre>{{ purchasingReturn }}</pre></div>
          <div class="col-md-4"><pre>{{ purchasing }}</pre></div>
        </div> -->
    </div>
</template>

<script>
import Axios from 'axios'
import { productUrl, getHeader, returnUrl, purchasingUrl, sale2Url, setQtyTotalUrl } from '../../config'
import { mapState } from 'vuex'
export default {
  name: 'PurchasingRetur',
  props: ['purchasing'],
  data () {
    return {
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: true /* doesn't work with directive */
      }
    }
  },
  computed: {
    ...mapState({
      uomList: state => state.uom.uomList,
      taxList: state => state.taxes.taxList,
      warehouseList: state => state.warehouses.warehouseList
    }),
    dataReturn () {
      return this.purchasing.returns[0]
    },
    purchasingReturn () {
      return this.purchasing.returns[0].details
    },
    totalSubtotalDetailReturn () {
      var sum = 0
      var array = this.purchasing.returns[0].details
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].amount.replace(/\./g, '')) * parseFloat(array[i].qty)
      }
      return sum
    },
    totalTaxDetailReturn () {
      var sum = 0
      var array = this.purchasing.returns[0].details
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].tax) * parseFloat(array[i].qty)
      }
      return sum
    },
    totalDetailReturn () {
      var sum = 0
      var array = this.purchasing.returns[0].details
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].total)
      }
      return sum
    },
    dataCollect () {
      var rtr = this.purchasing.returns[0]
      var detail = []
      var array = rtr.details.filter(d => d.product_no !== null)
      for (let i = 0; i < array.length; i++) {
        if (typeof array[i].id === 'undefined') {
          var obj = {
            return_no: null,
            product_no: array[i].product_no,
            product_sku: null,
            serial_number: array[i].serial_number,
            uom_id: array[i].uom_id,
            qty: array[i].qty,
            amount: array[i].amount.replace(/\./g, ''),
            notes: array[i].notes,
            warehouse_no: array[i].warehouse_no,
            branch_no: array[i].branch_no,
            company_no: array[i].company_no,
            discount: array[i].discount,
            discount_percentage: array[i].discount_percentage,
            tax_id: array[i].tax_id,
            tax: array[i].tax,
            total: array[i].total,
            return_date: null,
            cost: array[i].cost,
            cost_id: array[i].cost_id
          }
          detail.push(obj)
        } else {
          var obj2 = {
            id: array[i].id,
            return_no: array[i].return_no,
            product_no: array[i].product_no,
            product_sku: null,
            serial_number: array[i].serial_number,
            uom_id: array[i].uom_id,
            qty: array[i].qty,
            amount: array[i].amount.replace(/\./g, ''),
            notes: array[i].notes,
            warehouse_no: array[i].warehouse_no,
            branch_no: array[i].branch_no,
            company_no: array[i].company_no,
            discount: array[i].discount,
            discount_percentage: array[i].discount_percentage,
            tax_id: array[i].tax_id,
            tax: array[i].tax,
            total: array[i].total,
            return_date: null,
            cost: array[i].cost,
            cost_id: array[i].cost_id
          }
          detail.push(obj2)
        }
      }
      var data = {
        id: rtr.id,
        type: 'purchasing',
        return_no: null,
        return_date: rtr.return_date,
        deliver_date: rtr.deliver_date,
        vendor_no: this.purchasing.vendor_no,
        purchasing_no: this.purchasing.purchasing_no,
        sale_no: null,
        notes: rtr.notes,
        status: rtr.status,
        branch_no: this.purchasing.branch_no,
        company_no: this.purchasing.company_no,
        lock: rtr.lock,
        is_deliver: rtr.is_deliver,
        customer_no: null,
        subtotal: rtr.subtotal,
        discount: rtr.discount,
        discount_percentage: rtr.discount_percentage,
        tax_id: rtr.tax_id,
        tax: rtr.tax,
        total: rtr.total,
        details: detail
      }
      return data
    }
  },
  methods: {
    async setCOGSAll () {
      var array = this.purchasing.returns[0].details
      for (let i = 0; i < array.length; i++) {
        var date = new Date(array[i].return_date)
        var newDate = date.getFullYear() + '-' + (parseInt(date.getMonth()) + 1) + '-' + date.getDate()
        var data = {
          date: newDate,
          product_no: array[i].product_no,
          type: 'all',
          company_no: this.purchasing.company_no
        }
        console.log(data)
        await Axios.post(productUrl + '/cost/sync', data, { headers: getHeader() })
          .then(response => {
            console.log('success sync cogs')
            console.log(response.data.data)
            // this.$swal('Success', response.data.message, 'success')
          })
          .catch(error => {
            console.log(error)
            this.$swal('Error', error.response.data.message, 'error')
            throw error
          })
      }
    },
    setTax () {
      var array = this.purchasing.returns[0].details
      var tax = this.taxList.find(d => d.id === this.purchasing.returns[0].tax_id)
      for (let i = 0; i < array.length; i++) {
        var qty = parseFloat(array[i].qty)
        var amount = parseFloat(array[i].amount.replace(/\./g, ''))
        var taxAmount = amount * parseFloat(tax.amount) / 100
        var total = qty * (amount + taxAmount)
        array[i].tax_id = this.purchasing.returns[0].tax_id
        array[i].tax = taxAmount
        array[i].taxes = tax.name
        array[i].total = total
      }
      this.purchasing.returns[0].subtotal = this.totalSubtotalDetailReturn
      this.purchasing.returns[0].tax = this.totalTaxDetailReturn
      this.purchasing.returns[0].total = this.totalDetailReturn
    },
    async updateRetur () {
      var resp = {
        error: false,
        message: null
      }
      await Axios.put(returnUrl + '/' + this.dataReturn.id, this.dataCollect, { headers: getHeader() })
        .then(response => {
          console.log(response.data.message)
          resp.error = false
          resp.message = response.data.message
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
      await this.setCOGSAll()
      if (resp.error === false) {
        await this.$swal('Success', resp.message, 'success')
        await this.backParent()
      }
    },
    async createRetur () {
      await Axios.post(returnUrl, this.dataCollect, { headers: getHeader() })
        .then(response => {
          this.$swal('Success', response.data.message, 'success')
          this.backParent()
        })
        .catch(error => {
          console.log(error.response)
        })
    },
    async createScrap () {
      var resp = {
        error: false,
        message: null
      }
      this.dataCollect.type = 'scrap'
      await Axios.post(returnUrl, this.dataCollect, { headers: getHeader() })
        .then(response => {
          resp.error = false
          resp.message = response.data.message
        })
        .catch(error => {
          console.log(error.response)
          resp.error = false
          resp.message = error.response.data.message
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
      var array = this.dataCollect.details
      for (let i = 0; i < array.length; i++) {
        var code = array[i].product_no
        await this.setQtyTotal(code)
      }
      await this.$swal('Success', resp.message, 'success')
      await this.backParent()
    },
    async setQtyTotal (code) {
      var d = new Date()
      var n = d.getFullYear()
      var n1 = n - 1
      this.year = [n1, n]
      var newYear = d.getFullYear()
      var newMonth = d.getMonth() + 1
      var newDate = d.getDate()
      var newSetDate = newYear + '-' + newMonth + '-' + newDate
      var comNo = this.sales.company_no

      await Axios.get(setQtyTotalUrl + '?end=' + newSetDate + '&available=true&company_no=' + comNo + '&product_no=' + code, { headers: getHeader() })
        .then(response => {
          console.log(response.data.message)
        })
        .catch(error => {
          this.$swal(
            'Error',
            error.response.data.message,
            'error'
          )
        })
    },
    calcrow (index) {
      var detail = this.purchasing.returns[0].details[index]
      var qty = parseFloat(detail.qty)
      var amount = parseFloat(detail.amount.replace(/\./g, ''))
      var tax = parseFloat(detail.tax)
      var total = qty * (amount + tax)
      detail.total = total
      this.purchasing.returns[0].subtotal = this.totalSubtotalDetailReturn
      this.purchasing.returns[0].tax = this.totalTaxDetailReturn
      this.purchasing.returns[0].total = this.totalDetailReturn
    },
    removeReturn (index) {
      var rtr = this.purchasing.returns[0].details[index]
      if (typeof rtr.id === 'undefined') {
        this.purchasing.returns[0].details.splice(index, 1)
      } else {
        this.$swal.fire({
          title: 'Are you sure Delete this?',
          text: "You won't be able to revert this!",
          icon: 'error',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
          if (result.value) {
            Axios.delete(purchasingUrl + '/return/' + rtr.id, { headers: getHeader() })
              .then(response => {
                this.purchasing.returns[0].details.splice(index, 1)
              })
              .catch(error => {
                console.log(error.response)
              })
          }
        })
      }
    },
    addToReturn (index) {
      var sdetail = this.purchasing.details[index]
      console.log(sdetail)
      var warehouse = this.warehouseList.find(d => d.company_no === sdetail.company_no)
      var tax = this.taxList.find(d => d.id === sdetail.tax_id)
      var returnDetail = this.purchasing.returns[0].details.find(d => d.product_no === sdetail.product_no)
      console.log('returnDetail')
      console.log(returnDetail)
      var taxRetur = tax ? parseFloat(sdetail.price.replace(/\./g, '')) * parseFloat(tax.amount) / 100 : 0
      if (typeof returnDetail === 'undefined') {
        var totalRetur = parseFloat(sdetail.qty) * (parseFloat(sdetail.price.replace(/\./g, '')) + taxRetur)
        var obj = {
          return_no: null,
          product_no: sdetail.product_no,
          product: sdetail.product,
          product_sku: sdetail.product_sku,
          serial_number: null,
          uom_id: sdetail.uom_id,
          qty: sdetail.qty,
          amount: sdetail.price.replace(/\./g, ''),
          notes: sdetail.notes,
          warehouse_no: warehouse ? warehouse.warehouse_no : null,
          warehouse: warehouse ? warehouse.warehouse : null,
          branch_no: sdetail.branch_no,
          company_no: sdetail.company_no,
          discount: '0',
          discount_percentage: '0',
          tax_id: tax.id,
          tax: taxRetur,
          taxes: tax.name,
          total: totalRetur,
          cost: sdetail.subtotal,
          cost_id: null
        }
        this.purchasing.returns[0].details.push(obj)
      }

      this.purchasing.returns[0].subtotal = this.totalSubtotalDetailReturn
      this.purchasing.returns[0].tax = this.totalTaxDetailReturn
      this.purchasing.returns[0].total = this.totalDetailReturn
    },
    backParent () {
      this.$emit('backClicked')
    },
    printRetur () {
      window.open(sale2Url + '/print/' + this.purchasing.returns[0].id + '/return', '_blank')
    }
  }
}
</script>
